const EntityCreationParametersDefaults = {
  isNonbearing: false
};
export {
  EntityCreationParametersDefaults
};
//# sourceMappingURL=EntityCreationParameters.js.map
